import FaqItem from "./FaqItem";

const faqItems = document.querySelectorAll(".faq-item");

for (let i = 0; i < faqItems.length; i += 1) {
  const faqItem = new FaqItem(
    faqItems[i],
    ".faq-item__question",
    ".faq-item__answer",
    "is-open"
  );
  faqItem.init();
}
